import { render, staticRenderFns } from "./Departmentmanagement.vue?vue&type=template&id=d21fa732&scoped=true&"
import script from "./Departmentmanagement.vue?vue&type=script&lang=js&"
export * from "./Departmentmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Departmentmanagement.vue?vue&type=style&index=0&id=d21fa732&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21fa732",
  null
  
)

export default component.exports